module.exports = __webpack_public_path__ + "static/media/cp2.2e405a9e.png";